import { state as BST, status as BS } from '../../../helpers/buy';
import {
  isProjectAdmin, isPortfolioAdmin, isPolicyAdmin, isStratAdmin, isAdmin,
} from '../../../services/rolesSvc';

const isMyBuy = (userCtx, stratId, projId, state, portfId) => isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx);

const rules = {
  RequestEdit: { // создать новую версию закупки
    isStateOk: (state, status) => (status === BS.approved || status === BS.declined) && state === BST.none,
    isRoleOk: isMyBuy,
  },
  ViewVersions: {
    isStateOk: (state, status) => true,
    isRoleOk: isMyBuy,
  },
  SendTo1S: {
    isStateOk: (state, status) => status === BS.approved && state === BST.none,
    isRoleOk: (userCtx) => isAdmin(userCtx),
  },
  // RequestExclude: {},//todo
  Edit: { // check status?
    isStateOk: (state) => true,
    isRoleOk: (userCtx, stratId, projId, state, portfId) =>
    // РП может редактировать только на своей стадии
      ((state === BST.onProj || state === BST.onProjReturned || state === BST.onProjNewVersion) && isProjectAdmin(userCtx, projId))
            // РСП - на всех, кроме "У секретаря"
            || (state && state !== BST.onSecy && isStratAdmin(userCtx, stratId))
            // РПортф - на всех, кроме "У секретаря" и "У руководителя СП"
            || (state && state !== BST.onSecy && state !== BST.onStrat && state !== BST.onStratReturned && isPortfolioAdmin(userCtx, portfId))
            // ПО - всегда
            || isAdmin(userCtx),
  },
  SendToPortf: { // это первичная отправка со стадии РП, поэтому отправлять могут все причастные
    isStateOk: (state) => [BST.onProj, BST.onProjReturned, BST.onProjNewVersion].includes(state),
    isRoleOk: (userCtx, stratId, projId, state, portfId) => !!portfId && isMyBuy(userCtx, stratId, projId, state, portfId),
  },
  SendToStrat: { // здесь ничего не меняется
    isStateOk: (state) => [BST.onProj, BST.onProjReturned, BST.onProjNewVersion, BST.onPortf].includes(state),
    isRoleOk: (userCtx, stratId, projId, state, portfId) =>
      stratId //только для проектов в рамках СП
        // РПортф может отправлять только со своей стадии, и если проект портфельный
        && (!!portfId && state === BST.onPortf && (isPortfolioAdmin(userCtx, portfId) || isAdmin(userCtx))
        // РП и РСП - со стадии РП, если закупка не портфельного проекта
          || !portfId && state !== BST.onPortf && (isProjectAdmin(userCtx, projId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx))),
  },
  PortfReturn: { // отклонить со своей стадии может только РПортф (+ПО)
    isStateOk: (state) => state === BST.onPortf,
    isRoleOk: (userCtx, stratId, projId, state, portfId) => isPortfolioAdmin(userCtx, portfId) || isAdmin(userCtx),
  },
  StratReturn: { // отклонить со своей стадии может только РСП (+ПО)
    isStateOk: (state) => state === BST.onStrat || state === BST.onStratReturned,
    isRoleOk: (userCtx, stratId) => isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  SendToSecy: { // согласовать со своей стадии может только РСП (+ПО) + отправка со стадии "Черновик"/"На доработке" возможна для закупок проектов политик (без СП)
    isStateOk: (state) => [BST.onProj, BST.onProjReturned, BST.onProjNewVersion, BST.onStrat, BST.onStratReturned].includes(state),
    isRoleOk: (userCtx, stratId, projId, state, portfId) =>
        (!stratId && (state === BST.onProj || state === BST.onProjReturned || state === BST.onProjNewVersion) && (isProjectAdmin(userCtx, projId) || isAdmin(userCtx)))
        || (stratId && (state === BST.onStrat || state === BST.onStratReturned) && (isStratAdmin(userCtx, stratId) || isAdmin(userCtx))),
  },
  SecyReturn: { // отклонить со своей стадии может только ПО
    isStateOk: (state) => state === BST.onSecy,
    isRoleOk: (userCtx) => isAdmin(userCtx),
  },
  Approve: { // утвердить может только ПО
    isStateOk: (state) => state === BST.onSecy,
    isRoleOk: (userCtx) => isAdmin(userCtx),
  },
  Decline: { // отклонить может только ПО
    isStateOk: (state) => state === BST.onSecy,
    isRoleOk: (userCtx) => isAdmin(userCtx),
  },
};

export const getActionsModel = (status, state, userCtx, stratId, projId, portfId) => Object.entries(rules).reduce((acc, [key, rule]) => ({
  ...acc,
  [key]: rule.isStateOk(state, status) && rule.isRoleOk(userCtx, stratId, projId, state, portfId),
}), {});
